<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="main_area">
      <div style="clear: both"></div>
      <div class="information">
        <h3>{{ pageData.MenuName }}</h3>
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>機關</td>
              <td>
                <p>
                  <select
                    v-model="form.govCode1"
                    style="min-width: 200px"
                    @change="GovCode1Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 1
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="form.govCode2"
                    style="min-width: 200px"
                    @change="GovCode2Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 2
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="form.govCode3"
                    style="min-width: 200px"
                    @change="GovCode3Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 3
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="form.govCode4"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 4
                    "
                  >
                    <option
                      v-for="(item, index) in dropDownList.govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <a
                    style="position: absolute"
                    href="/PdpsCli/download/S304_UserGuide.pdf"
                    target="_blank"
                    >下載操作說明</a
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td>機關代碼</td>
              <td>
                <input type="text" v-model="form.govCode" maxlength="10" />
              </td>
            </tr>
            <tr>
              <td>機關名稱</td>
              <td><input type="text" v-model="form.govName" size="30" /></td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd('I', '')"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="btnClear()"
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
      <!-- 查詢結果開始-->
      <div class="information">
        <table width="100%">
          <tr>
            <td v-if="grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th colspan="3">操作</th>
                  <th width="10%">
                    <u
                      style="cursor: pointer"
                      target="_blank"
                      @click="
                        () => {
                          this.reQuery('GOV_CODE', Sort);
                        }
                      "
                      >服務機關代碼</u
                    >
                  </th>
                  <th width="10%">
                    <u
                      style="cursor: pointer"
                      target="_blank"
                      @click="
                        () => {
                          this.reQuery('GOV_NAME', Sort);
                        }
                      "
                      >服務機關名稱</u
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in grid.gridDatas" :key="index">
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="修改機關"
                      data-toggle="modal"
                      data-target=".bs-example-modal-lg"
                      @click="btnAdd('U1', data)"
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="修改受理申報機關"
                      data-toggle="modal"
                      data-target=".bs-example-modal-lg"
                      @click="btnAdd('U2', data)"
                    />
                  </td>
                  <td width="1%" align="center">
                    <input
                      type="button"
                      class="btn"
                      value="刪"
                      data-toggle="modal"
                      data-target=".bs-example-modal-lg"
                      @click="btnCheckDelete(data)"
                    />
                  </td>
                  <td>{{ data.goV_CODE }}</td>
                  <td>{{ data.goV_NAME }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </div>

    <AddModal
      v-model="addModal.show"
      :title="addModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tr>
              <td>機關代碼</td>
              <td>
                <input
                  type="text"
                  v-model="addModal.form.govCode"
                  :disabled="
                    addModal.form.type == 'U1' || addModal.form.type == 'U2'
                  "
                  maxlength="10"
                />
              </td>
              <td>機關名稱</td>
              <td>
                <input type="text" v-model="addModal.form.govName" size="30" />
              </td>
            </tr>
            <tr>
              <td>機關層級</td>
              <td colspan="3">
                <p>
                  <select
                    v-model="addModal.form.govCode1"
                    style="min-width: 200px"
                    @change="addModalGovCode1Change()"
                    :disabled="
                      (addModal.form.type == 'U1' &&
                        (addModal.form.joblayerNum > 1 ||
                          addModal.form.AllLock) &&
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 1) ||
                      addModal.form.type == 'U2' ||
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 1)
                    "
                  >
                    <option
                      v-for="(item, index) in addModal.dropDownList.govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="addModal.form.govCode2"
                    style="min-width: 200px"
                    @change="addModalGovCode2Change()"
                    :disabled="
                      (addModal.form.type == 'U1' &&
                        (addModal.form.joblayerNum > 2 ||
                          addModal.form.AllLock) &&
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 2) ||
                      addModal.form.type == 'U2' ||
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 2)
                    "
                  >
                    <option
                      v-for="(item, index) in addModal.dropDownList.govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="addModal.form.govCode3"
                    style="min-width: 200px"
                    @change="addModalGovCode3Change()"
                    :disabled="
                      (addModal.form.type == 'U1' &&
                        (addModal.form.joblayerNum > 3 ||
                          addModal.form.AllLock) &&
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 3) ||
                      addModal.form.type == 'U2' ||
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 3)
                    "
                  >
                    <option
                      v-for="(item, index) in addModal.dropDownList.govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="addModal.form.govCode4"
                    style="min-width: 200px"
                    :disabled="
                      (addModal.form.type == 'U1' &&
                        (4 <= addModal.form.joblayerNum ||
                          addModal.form.AllLock) &&
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 4) ||
                      addModal.form.type == 'U2' ||
                      (loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        loginInfo.layerNum >= 4)
                    "
                  >
                    <option
                      v-for="(item, index) in addModal.dropDownList.govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </p>
              </td>
            </tr>
            <tr>
              <td>機關地址</td>
              <td colspan="3">
                <input
                  type="text"
                  size="100"
                  maxlength="100"
                  v-model="addModal.form.addr"
                />
              </td>
            </tr>
            <tr v-show="addModal.form.type == 'U2'">
              <td>受理申報機關</td>
              <td colspan="3">
                <select
                  v-model="addModal.form.jobGovCode1"
                  style="min-width: 200px"
                  @change="addModalJobGovCode1Change()"
                  :disabled="
                    (addModal.form.type == 'I' && loginInfo.roleSeq != 1) ||
                    (addModal.form.type == 'U2' &&
                      (addModal.form.joblayerNum >= 1 ||
                        addModal.form.jobGovCodeAllLock) &&
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 1) ||
                    (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 1)
                  "
                >
                  <option
                    v-for="(item, index) in addModal.dropDownList.jobGovCode1s"
                    :value="item.value"
                    :key="index"
                  >
                    {{ item.text }}
                  </option>
                </select>
                <select
                  v-model="addModal.form.jobGovCode2"
                  style="min-width: 200px"
                  @change="addModalJobGovCode2Change()"
                  :disabled="
                    addModal.form.type == 'I' ||
                    (addModal.form.type == 'U2' &&
                      (addModal.form.joblayerNum >= 2 ||
                        addModal.form.jobGovCodeAllLock) &&
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 2) ||
                    (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 2)
                  "
                >
                  <option
                    v-for="(item, index) in addModal.dropDownList.jobGovCode2s"
                    :value="item.value"
                    :key="index"
                  >
                    {{ item.text }}
                  </option>
                </select>
                <select
                  v-model="addModal.form.jobGovCode3"
                  style="min-width: 200px"
                  @change="addModalJobGovCode3Change()"
                  :disabled="
                    addModal.form.type == 'I' ||
                    (addModal.form.type == 'U2' &&
                      (addModal.form.layerNum >= 3 ||
                        addModal.form.jobGovCodeAllLock) &&
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 3) ||
                    (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 3)
                  "
                >
                  <option
                    v-for="(item, index) in addModal.dropDownList.jobGovCode3s"
                    :value="item.value"
                    :key="index"
                  >
                    {{ item.text }}
                  </option>
                </select>
                <select
                  v-model="addModal.form.jobGovCode4"
                  style="min-width: 200px"
                  :disabled="
                    addModal.form.type == 'I' ||
                    (addModal.form.type == 'U2' &&
                      (addModal.form.joblayerNum > 4 ||
                        addModal.form.jobGovCodeAllLock) &&
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 4) ||
                    (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      loginInfo.layerNum >= 4)
                  "
                >
                  <option
                    v-for="(item, index) in addModal.dropDownList.jobGovCode4s"
                    :value="item.value"
                    :key="index"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </td>
            </tr>
            <tr v-show="addModal.form.type == 'U2'">
              <td>受理申報單位</td>
              <td colspan="3">
                <input
                  type="text"
                  v-model="addModal.form.jobGovName"
                  size="30"
                  :disabled="
                    addModal.form.type == 'I' || addModal.form.type == 'U1'
                  "
                />
              </td>
            </tr>
            <tr>
              <td colspan="4" class="f_center">
                <label for="checkbox"
                  ><span>
                    <input
                      type="submit"
                      class="btn"
                      value="存檔"
                      @click="btnModalSave()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="btnModalClear()"
                      :disabled="
                        addModal.form.type == 'U2' || addModal.form.type == 'U1'
                      "
                    /> </span
                ></label>
              </td>
            </tr>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <Confirm
      v-model="Confirm.show"
      :title="Confirm.title"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div style="text-align: center">
        <div
          v-for="(data, index) in Confirm.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Confirm.BtnOK">確定</button>
          <button class="btn" @click="Confirm.BtnCancel">取消</button>
        </div>
      </div>
    </Confirm>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  S304_QueryGrid,
  S304_ReQueryGrid,
  S304_Remove,
  S304_AddSave,
  S304_Edit,
  S304_EditSave,
} from "@/service/api.js";
export default {
  name: "S304",
  data: function () {
    return {
      pageData: {
        MenuIndex: 6,
        MenuName: "",
        PrgName: "S304",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCode: "",
        govName: "",
        pagesize: 10,
        currentpage: 1,
      },
      grid: [],
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
      },
      addModal: {
        show: false,
        title: "S304服務機關資料維護-編輯受理申報機關",
        form: {
          pkno: 0,
          type: "",
          govCode1: "",
          govCode2: "",
          govCode3: "",
          govCode4: "",
          o_jobGovCode1: "",
          o_jobGovCode2: "",
          o_jobGovCode3: "",
          o_jobGovCode4: "",
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          AllLock: false,
          layerNum: "",
          jobGovCodeAllLock: false,
          joblayerNum: "",
          govCode: "",
          govName: "",
          addr: "",
          upGovCode: "",
          govCodeStr: "",
          jobGovCode: "",
          jobGovCodeStr: "",
          jobGovName: "",
        },
        grid: [],
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      Confirm: {
        show: false,
        title: "",
        txt: [],
        BtnOK: function () {
          this.Confirm.show = false;
        },
        BtnCancel: function () {
          this.Confirm.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    Alert: VueModal,
    Confirm: VueModal,
    AddModal: VueModal,
  },
  methods: {
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得服務機關第一層類別 addModal
    modalGetSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別 addModal
    modalGetSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別 addModal
    modalGetSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別 addModal
    modalGetSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    modalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    modalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    modalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    modalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.addModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        goV_CODE_LIST: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOV_CODE: self.form.govCode,
        GOV_NAME: self.form.govName,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S304_QueryGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "GOV_CODE";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        goV_CODE_LIST: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOV_CODE: self.form.govCode,
        GOV_NAME: self.form.govName,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      S304_ReQueryGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    btnAdd: function (type, data) {
      const self = this;
      self.addModal.form.type = type;
      if (type == "U1" || type == "U2") {
        let postData = {
          pkno: data.pkno,
          GOV_CODE: data.goV_CODE,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd:
              type == "U1"
                ? "修改機關-編"
                : type == "U2"
                ? "修改受理申報機關-編"
                : "",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        //若異動受理申報機關須跳警訊
        //for (var i = 0; i < 3; i++) {
        S304_Edit(postData).then((rData) => {
          self.addModal.grid = rData.returnObject;
          self.addModal.form.pkno = data.pkno;
          self.addModal.form.govCode1 =
            rData.returnObject.goV_CODE_STR.split(",")[0] ==
            rData.returnObject.goV_CODE
              ? ""
              : rData.returnObject.goV_CODE_STR.split(",")[0];
          self.addModal.form.govCode2 =
            rData.returnObject.goV_CODE_STR.split(",")[1] ==
            rData.returnObject.goV_CODE
              ? ""
              : rData.returnObject.goV_CODE_STR.split(",")[1];
          self.addModal.form.govCode3 =
            rData.returnObject.goV_CODE_STR.split(",")[2] ==
            rData.returnObject.goV_CODE
              ? ""
              : rData.returnObject.goV_CODE_STR.split(",")[2];
          self.addModal.form.govCode4 =
            rData.returnObject.goV_CODE_STR.split(",")[3] ==
            rData.returnObject.goV_CODE
              ? ""
              : rData.returnObject.goV_CODE_STR.split(",")[3];
          // self.addModal.form.jobGovCode1 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[0]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[0];
          // self.addModal.form.jobGovCode2 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[1]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[1];
          // self.addModal.form.jobGovCode3 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[2]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[2];
          // self.addModal.form.jobGovCode4 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[3]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[3];

          // self.addModal.form.o_jobGovCode1 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[0]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[0];
          // self.addModal.form.o_jobGovCode2 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[1]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[1];
          // self.addModal.form.o_jobGovCode3 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[2]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[2];
          // self.addModal.form.o_jobGovCode4 = !rData.returnObject.r_UNIT_CODE_STR
          //   ? rData.returnObject.goV_CODE_STR.split(",")[3]
          //   : rData.returnObject.r_UNIT_CODE_STR.split(",")[3];
          self.addModal.form.jobGovCode1 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[0]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[0];
          self.addModal.form.jobGovCode2 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[1]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[1];
          self.addModal.form.jobGovCode3 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[2]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[2];
          self.addModal.form.jobGovCode4 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[3]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[3];

          self.addModal.form.o_jobGovCode1 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[0]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[0];
          self.addModal.form.o_jobGovCode2 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[1]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[1];
          self.addModal.form.o_jobGovCode3 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[2]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[2];
          self.addModal.form.o_jobGovCode4 = !rData.returnObject.r_UNIT_CODE_STR
            ? self.loginInfo.govCodeStr.split(",")[3]
            : rData.returnObject.r_UNIT_CODE_STR.split(",")[3];

          //受理機關層級卡控
          if (self.addModal.form.jobGovCode4) {
            self.addModal.form.joblayerNum = 4;
            self.addModal.form.jobGovCodeAllLock = false;
          } else if (self.addModal.form.jobGovCode3) {
            self.addModal.form.joblayerNum = 3;
            self.addModal.form.jobGovCodeAllLock = false;
          } else if (self.addModal.form.jobGovCode2) {
            self.addModal.form.joblayerNum = 2;
            self.addModal.form.jobGovCodeAllLock = false;
          } else {
            self.addModal.form.joblayerNum = 1;
            self.addModal.form.jobGovCodeAllLock = true;
          }
          //機關層級卡控
          if (self.addModal.form.govCode4) {
            self.addModal.form.layerNum = 4;
            self.addModal.form.AllLock = false;
          } else if (self.addModal.form.govCode3) {
            self.addModal.form.layerNum = 3;
            self.addModal.form.AllLock = false;
          } else if (self.addModal.form.govCode2) {
            self.addModal.form.layerNum = 2;
            self.addModal.form.AllLock = false;
          } else if (self.addModal.form.govCode1) {
            self.addModal.form.layerNum = 1;
            self.addModal.form.AllLock = false;
          } else {
            self.addModal.form.layerNum = 1;
            self.addModal.form.AllLock = true;
          }
          self.addModal.form.govCode = rData.returnObject.goV_CODE;
          self.addModal.form.govName = rData.returnObject.goV_NAME;
          self.addModal.form.addr = rData.returnObject.addr;
          self.addModal.form.upGovCode = rData.returnObject.uP_GOV_CODE;
          self.addModal.form.govCodeStr = rData.returnObject.goV_CODE_STR;
          self.addModal.form.jobGovCode = rData.returnObject.r_UNIT_CODE;
          self.addModal.form.jobGovCodeStr = rData.returnObject.r_UNIT_CODE_STR;
          self.addModal.form.jobGovName = rData.returnObject.r_UNIT_NAME;

          //self.waitThisEnd();

          if (type == "U1")
            self.addModal.title = "S304服務機關資料維護-編輯機關";
          if (type == "U2")
            self.addModal.title = "S304服務機關資料維護-編輯受理申報機關";

          self.addModal.show = true;
        });
        //}
        self.modalGetSearchGovCode1();
        self.modalGetSearchJobGovCode1();
      } else {
        self.addModal.title = "S304服務機關資料維護-新增機關";
        self.addModal.show = true;
        self.btnModalClear();
      }
    },
    btnClear: function () {
      const self = this;
      self.form.govCode = "";
      self.form.govName = "";
      self.GovCodeInit(self.form, false);
      self.getSearchGovCode1();
    },
    GovCodeInit: function (form, isLayer) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          if (isLayer) {
            form.govCode1 = govCodeArray[1] != "" ? govCodeArray[0] : "";
            form.govCode2 = govCodeArray[2] != "" ? govCodeArray[1] : "";
            form.govCode3 = govCodeArray[3] != "" ? govCodeArray[2] : "";
            form.govCode4 = "";
          } else {
            form.govCode1 = govCodeArray[0];
            form.govCode2 = govCodeArray[1];
            form.govCode3 = govCodeArray[2];
            form.govCode4 = govCodeArray[3];
          }
        }
      }
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    addModalGovCode1Change: function () {
      const self = this;
      self.addModal.form.govCode2 = "";
      self.addModal.form.govCode3 = "";
      self.addModal.form.govCode4 = "";
      self.addModal.dropDownList.govCode2s = [];
      self.addModal.dropDownList.govCode3s = [];
      self.addModal.dropDownList.govCode4s = [];
    },
    addModalGovCode2Change: function () {
      const self = this;
      self.addModal.form.govCode3 = "";
      self.addModal.form.govCode4 = "";
      self.addModal.dropDownList.govCode3s = [];
      self.addModal.dropDownList.govCode4s = [];
    },
    addModalGovCode3Change: function () {
      const self = this;
      self.addModal.form.govCode4 = "";
      self.addModal.dropDownList.govCode4s = [];
    },
    addModalJobGovCode1Change: function () {
      const self = this;
      self, (addModal.form.jobGovCode2 = "");
      self.addModal.form.jobGovCode3 = "";
      self.addModal.form.jobGovCode4 = "";
      self.addModal.dropDownList.jobGovCode2s = [];
      self.addModal.dropDownList.jobGovCode3s = [];
      self.addModal.dropDownList.jobGovCode4s = [];
    },
    addModalJobGovCode2Change: function () {
      const self = this;
      self.addModal.form.jobGovCode3 = "";
      self.addModal.form.jobGovCode4 = "";
      self.addModal.dropDownList.jobGovCode3s = [];
      self.addModal.dropDownList.jobGovCode4s = [];
    },
    addModalJobGovCode3Change: function () {
      const self = this;
      self.addModal.form.jobGovCode4 = "";
      self.addModal.dropDownList.jobGovCode4s = [];
    },
    btnCheckDelete: function (data) {
      const self = this;
      self.Confirm.show = true;
      self.Confirm.txt = ["請確定是否刪除??"];
      self.Confirm.title = "訊息";
      self.Confirm.BtnOK = function () {
        self.btnDelete(data);
        self.Confirm.show = false;
      };
      self.Confirm.BtnCancel = function () {
        self.Confirm.show = false;
      };
    },
    btnDelete: function (data) {
      const self = this;
      let postData = {
        pkno: data.pkno,
        GOV_CODE: data.goV_CODE,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S304_Remove(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.form.Selected = [];
            self.addModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    btnModalSave: function () {
      const self = this;
      let postData = {};
      let errorMsg = [];
      var layerNum = 1;
      if (self.addModal.form.govCode1 == "") {
        layerNum = 1;
      } else if (self.addModal.form.govCode2 == "") {
        layerNum = 2;
      } else if (self.addModal.form.govCode3 == "") {
        layerNum = 3;
      } else {
        layerNum = 4;
      }
      if (self.addModal.form.type == "I") {
        if (self.addModal.form.govCode.trim() == "")
          errorMsg.push("請填寫機關代碼");
        else if (self.addModal.form.govCode.trim().length < 10)
          errorMsg.push("請填寫正確機關代碼，需要十碼");
        if (self.addModal.form.govName.trim() == "")
          errorMsg.push("請填寫機關名稱");
        if (self.addModal.form.addr.trim() == "")
          errorMsg.push("請填寫機關地址");
      }
      if (self.addModal.form.type == "U1") {
        if (self.addModal.form.govName.trim() == "")
          errorMsg.push("請填寫機關名稱");
        if (self.addModal.form.addr.trim() == "")
          errorMsg.push("請填寫機關地址");
      }
      if (self.addModal.form.type == "U2") {
        if (self.addModal.form.govName.trim() == "")
          errorMsg.push("請填寫機關名稱");
        if (self.addModal.form.addr.trim() == "")
          errorMsg.push("請填寫機關地址");
        if (self.addModal.form.jobGovCode1 == "")
          errorMsg.push("請選擇受理申報機關");
        if (self.addModal.form.jobGovName == null)
          errorMsg.push("請填寫受理申報單位");
        else if (self.addModal.form.jobGovName.trim() == "") {
          errorMsg.push("請填寫受理申報單位");
        }
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      if (self.addModal.form.type == "U2") {
        if (
          self.addModal.form.jobGovCode1 != self.addModal.form.o_jobGovCode1 ||
          self.addModal.form.jobGovCode2 != self.addModal.form.o_jobGovCode2 ||
          self.addModal.form.jobGovCode3 != self.addModal.form.o_jobGovCode3 ||
          self.addModal.form.jobGovCode4 != self.addModal.form.o_jobGovCode4
        ) {
          self.Confirm.txt = ["請確定是否修改受理申報單位??"];
          self.Confirm.title = "訊息";
          self.Confirm.show = true;
          self.Confirm.BtnOK = function () {
            postData = {
              pkno: self.addModal.form.pkno,
              GOV_CODE: self.addModal.form.govCode,
              GOV_NAME: self.addModal.form.govName,
              UP_GOV_CODE:
                self.addModal.form.govCode4 != ""
                  ? self.addModal.form.govCode4
                  : self.addModal.form.govCode3 != ""
                  ? self.addModal.form.govCode3
                  : self.addModal.form.govCode2 != ""
                  ? self.addModal.form.govCode2
                  : self.addModal.form.govCode1 != ""
                  ? self.addModal.form.govCode1
                  : "", //self.addModal.form.upGovCode,
              ADDR: self.addModal.form.addr,
              LAYER_NUM: String(layerNum),
              GOV_CODE_STR:
                (self.addModal.form.govCode1 == ""
                  ? self.addModal.form.govCode
                  : self.addModal.form.govCode1) +
                "," +
                (self.addModal.form.govCode2 == "" &&
                self.addModal.form.govCode1 != ""
                  ? self.addModal.form.govCode
                  : self.addModal.form.govCode2) +
                "," +
                (self.addModal.form.govCode3 == "" &&
                self.addModal.form.govCode1 != "" &&
                self.addModal.form.govCode2 != ""
                  ? self.addModal.form.govCode
                  : self.addModal.form.govCode3) +
                "," +
                (self.addModal.form.govCode4 == "" &&
                self.addModal.form.govCode1 != "" &&
                self.addModal.form.govCode2 != "" &&
                self.addModal.form.govCode3 != ""
                  ? self.addModal.form.govCode
                  : self.addModal.form.govCode4),
              R_GOV_CODE:
                self.addModal.form.jobGovCode4 != ""
                  ? self.addModal.form.jobGovCode4
                  : self.addModal.form.jobGovCode3 != ""
                  ? self.addModal.form.jobGovCode3
                  : self.addModal.form.jobGovCode2 != ""
                  ? self.addModal.form.jobGovCode2
                  : self.addModal.form.jobGovCode1 != ""
                  ? self.addModal.form.jobGovCode1
                  : "",
              R_UNIT_CODE:
                self.addModal.form.jobGovCode4 != ""
                  ? self.addModal.form.jobGovCode4
                  : self.addModal.form.jobGovCode3 != ""
                  ? self.addModal.form.jobGovCode3
                  : self.addModal.form.jobGovCode2 != ""
                  ? self.addModal.form.jobGovCode2
                  : self.addModal.form.jobGovCode1 != ""
                  ? self.addModal.form.jobGovCode1
                  : "",
              TYPE: "U2",
              R_UNIT_NAME: self.addModal.form.jobGovName,
              LogInfo: {
                Id: self.loginInfo.id,
                PrgCode: self.pageData.PrgName,
                ActCd:
                  self.addModal.form.type == "U1"
                    ? "修改機關-存檔"
                    : self.addModal.form.type == "U2"
                    ? "修改受理申報機關-存檔"
                    : "",
                ServiceUnit: self.pageData.ServiceUnit,
                Token: self.loginInfo.token,
              },
            };
            Object.keys(postData).map(
              (k) =>
                (postData[k] =
                  typeof postData[k] == "string"
                    ? postData[k].trim()
                    : postData[k])
            );
            S304_EditSave(postData).then((rData) => {
              if (rData.result) {
                self.Alert.show = true;
                self.Alert.title = "訊息";
                self.Alert.txt = ["更新成功"];
                self.Alert.BtnConfirm = () => {
                  self.Alert.show = false;
                  self.addModal.show = false;
                  //self.GovCodeInit(self.form, false);
                  self.getSearchGovCode1();
                  self.doQuery();
                };
              } else {
                self.Alert.show = true;
                self.Alert.title = "錯誤";
                self.Alert.txt = [rData.messages[0]]; //["更新失敗"];
                self.Alert.BtnConfirm = () => (self.Alert.show = false);
                self.addModal.show = false;
              }
            });
            self.Confirm.show = false;
          };
          self.Confirm.BtnCancel = function () {
            self.Confirm.show = false;
            return false;
          };
        } else {
          postData = {
            pkno: self.addModal.form.pkno,
            GOV_CODE: self.addModal.form.govCode,
            GOV_NAME: self.addModal.form.govName,
            UP_GOV_CODE:
              self.addModal.form.govCode4 != ""
                ? self.addModal.form.govCode4
                : self.addModal.form.govCode3 != ""
                ? self.addModal.form.govCode3
                : self.addModal.form.govCode2 != ""
                ? self.addModal.form.govCode2
                : self.addModal.form.govCode1 != ""
                ? self.addModal.form.govCode1
                : "", //self.addModal.form.upGovCode,
            ADDR: self.addModal.form.addr,
            LAYER_NUM: String(layerNum),
            GOV_CODE_STR:
              (self.addModal.form.govCode1 == ""
                ? self.addModal.form.govCode
                : self.addModal.form.govCode1) +
              "," +
              (self.addModal.form.govCode2 == "" &&
              self.addModal.form.govCode1 != ""
                ? self.addModal.form.govCode
                : self.addModal.form.govCode2) +
              "," +
              (self.addModal.form.govCode3 == "" &&
              self.addModal.form.govCode1 != "" &&
              self.addModal.form.govCode2 != ""
                ? self.addModal.form.govCode
                : self.addModal.form.govCode3) +
              "," +
              (self.addModal.form.govCode4 == "" &&
              self.addModal.form.govCode1 != "" &&
              self.addModal.form.govCode2 != "" &&
              self.addModal.form.govCode2 != ""
                ? self.addModal.form.govCode
                : self.addModal.form.govCode4),
            R_GOV_CODE:
              self.addModal.form.jobGovCode4 != ""
                ? self.addModal.form.jobGovCode4
                : self.addModal.form.jobGovCode3 != ""
                ? self.addModal.form.jobGovCode3
                : self.addModal.form.jobGovCode2 != ""
                ? self.addModal.form.jobGovCode2
                : self.addModal.form.jobGovCode1 != ""
                ? self.addModal.form.jobGovCode1
                : "",
            R_UNIT_CODE:
              self.addModal.form.jobGovCode4 != ""
                ? self.addModal.form.jobGovCode4
                : self.addModal.form.jobGovCode3 != ""
                ? self.addModal.form.jobGovCode3
                : self.addModal.form.jobGovCode2 != ""
                ? self.addModal.form.jobGovCode2
                : self.addModal.form.jobGovCode1 != ""
                ? self.addModal.form.jobGovCode1
                : "",
            R_UNIT_NAME: self.addModal.form.jobGovName,
            LogInfo: {
              Id: self.loginInfo.id,
              PrgCode: self.pageData.PrgName,
              ActCd:
                self.addModal.form.type == "U1"
                  ? "修改機關-存檔"
                  : self.addModal.form.type == "U2"
                  ? "修改受理申報機關-存檔"
                  : "",
              ServiceUnit: self.pageData.ServiceUnit,
              Token: self.loginInfo.token,
            },
          };
          Object.keys(postData).map(
            (k) =>
              (postData[k] =
                typeof postData[k] == "string"
                  ? postData[k].trim()
                  : postData[k])
          );
          S304_EditSave(postData).then((rData) => {
            if (rData.result) {
              self.Alert.show = true;
              self.Alert.title = "訊息";
              self.Alert.txt = ["更新成功"];
              self.Alert.BtnConfirm = () => {
                self.Alert.show = false;
                self.addModal.show = false;
                //self.GovCodeInit(self.form, false);
                self.getSearchGovCode1();
                self.doQuery();
              };
            } else {
              self.Alert.show = true;
              self.Alert.title = "錯誤";
              self.Alert.txt = [rData.messages[0]]; //["更新失敗"];
              self.Alert.BtnConfirm = () => (self.Alert.show = false);
              self.addModal.show = false;
            }
          });
        }
      }

      if (self.addModal.form.type == "U1") {
        postData = {
          pkno: self.addModal.form.pkno,
          GOV_CODE: self.addModal.form.govCode,
          GOV_NAME: self.addModal.form.govName,
          UP_GOV_CODE:
            self.addModal.form.govCode4 != ""
              ? self.addModal.form.govCode4
              : self.addModal.form.govCode3 != ""
              ? self.addModal.form.govCode3
              : self.addModal.form.govCode2 != ""
              ? self.addModal.form.govCode2
              : self.addModal.form.govCode1 != ""
              ? self.addModal.form.govCode1
              : "", //self.addModal.form.upGovCode,
          ADDR: self.addModal.form.addr,
          LAYER_NUM: String(layerNum),
          GOV_CODE_STR:
            (self.addModal.form.govCode1 == ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode1) +
            "," +
            (self.addModal.form.govCode2 == "" &&
            self.addModal.form.govCode1 != ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode2) +
            "," +
            (self.addModal.form.govCode3 == "" &&
            self.addModal.form.govCode1 != "" &&
            self.addModal.form.govCode2 != ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode3) +
            "," +
            (self.addModal.form.govCode4 == "" &&
            self.addModal.form.govCode1 != "" &&
            self.addModal.form.govCode2 != "" &&
            self.addModal.form.govCode3 != ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode4),
          R_GOV_CODE:
            self.addModal.form.jobGovCode4 != ""
              ? self.addModal.form.jobGovCode4
              : self.addModal.form.jobGovCode3 != ""
              ? self.addModal.form.jobGovCode3
              : self.addModal.form.jobGovCode2 != ""
              ? self.addModal.form.jobGovCode2
              : self.addModal.form.jobGovCode1 != ""
              ? self.addModal.form.jobGovCode1
              : "",
          R_UNIT_CODE:
            self.addModal.form.jobGovCode4 != ""
              ? self.addModal.form.jobGovCode4
              : self.addModal.form.jobGovCode3 != ""
              ? self.addModal.form.jobGovCode3
              : self.addModal.form.jobGovCode2 != ""
              ? self.addModal.form.jobGovCode2
              : self.addModal.form.jobGovCode1 != ""
              ? self.addModal.form.jobGovCode1
              : "",
          R_UNIT_NAME: self.addModal.form.jobGovName,
          TYPE: "U1",
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd:
              self.addModal.form.type == "U1"
                ? "修改機關-存檔"
                : self.addModal.form.type == "U2"
                ? "修改受理申報機關-存檔"
                : "",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        S304_EditSave(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["更新成功"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
              self.addModal.show = false;
              //self.GovCodeInit(self.form, false);
              self.getSearchGovCode1();
              self.doQuery();
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [rData.messages[0]]; //["更新失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
            self.addModal.show = false;
          }
        });
      }

      if (self.addModal.form.type == "I") {
        postData = {
          GOV_CODE: self.addModal.form.govCode,
          GOV_NAME: self.addModal.form.govName,
          UP_GOV_CODE:
            self.addModal.form.govCode4 != ""
              ? self.addModal.form.govCode4
              : self.addModal.form.govCode3 != ""
              ? self.addModal.form.govCode3
              : self.addModal.form.govCode2 != ""
              ? self.addModal.form.govCode2
              : self.addModal.form.govCode1 != ""
              ? self.addModal.form.govCode1
              : "",
          //self.addModal.form.upGovCode,
          ADDR: self.addModal.form.addr,
          LAYER_NUM: String(layerNum),
          GOV_CODE_STR:
            (self.addModal.form.govCode1 == ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode1) +
            "," +
            (self.addModal.form.govCode2 == "" &&
            self.addModal.form.govCode1 != ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode2) +
            "," +
            (self.addModal.form.govCode3 == "" &&
            self.addModal.form.govCode1 != "" &&
            self.addModal.form.govCode2 != ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode3) +
            "," +
            (self.addModal.form.govCode4 == "" &&
            self.addModal.form.govCode1 != "" &&
            self.addModal.form.govCode2 != "" &&
            self.addModal.form.govCode3 != ""
              ? self.addModal.form.govCode
              : self.addModal.form.govCode4),
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "第二頁新增",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        };
        Object.keys(postData).map(
          (k) =>
            (postData[k] =
              typeof postData[k] == "string" ? postData[k].trim() : postData[k])
        );
        S304_AddSave(postData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["新增成功"];
            self.Alert.BtnConfirm = () => {
              let postData2 = rData.returnObject;
              self.addModal.form.type == "U2";
              // self.GovCodeInit(self.form, false);
              self.getSearchGovCode1();
              self.btnAdd("U2", postData2);
              self.doQuery();
              self.Alert.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [rData.messages[0]]; //["新增失敗"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
            self.addModal.show = false;
          }
        });
      }
      //重新Reload
      self.modalGetSearchGovCode1();
      self.modalGetSearchJobGovCode1();
      self.getSearchGovCode1();
    },
    btnModalClear: function () {
      const self = this;
      self.addModal.form.govCode1 = "";
      self.addModal.form.govCode2 = "";
      self.addModal.form.govCode3 = "";
      self.addModal.form.govCode4 = "";
      self.addModal.form.jobGovCode1 = "";
      self.addModal.form.jobGovCode2 = "";
      self.addModal.form.jobGovCode3 = "";
      self.addModal.form.jobGovCode4 = "";
      self.addModal.form.layerNum = "";
      self.addModal.form.govCode = "";
      self.addModal.form.govName = "";
      self.addModal.form.addr = "";
      self.addModal.form.upGovCode = "";
      self.addModal.form.govCodeStr = "";
      self.addModal.form.jobGovName = "";
      self.form.jobGovCode = "";
      self.form.jobGovName = "";
      self.form.AllLock = false;
      self.form.layerNum = "";
      self.form.jobGovCodeAllLock = false;
      self.form.joblayerNum = "";

      self.modalGetSearchGovCode1();
      self.modalGetSearchJobGovCode1();
      self.GovCodeInit(this.addModal.form, false);
      self.JobGovCodeInit(this.addModal.form);
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.GovCodeInit(self.form, false);
    self.getSearchGovCode1();
    self.doQuery();
  },
  watch: {
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "addModal.form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode2(newValue);
    },
    "addModal.form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode3(newValue);
    },
    "addModal.form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode4(newValue);
    },
    "addModal.form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchJobGovCode2(newValue);
    },
    "addModal.form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchJobGovCode3(newValue);
    },
    "addModal.form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchJobGovCode4(newValue);
    },
    "dropDownList.govCode1s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.form.govCode1 != "")
        this.getSearchGovCode2(self.form.govCode1);
    },
    "dropDownList.govCode2s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.form.govCode2 != "")
        this.getSearchGovCode3(self.form.govCode2);
    },
    "dropDownList.govCode3s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.form.govCode3 != "")
        this.getSearchGovCode4(self.form.govCode3);
    },
    "addModal.dropDownList.govCode1s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.addModal.form.govCode1 != "")
        this.modalGetSearchGovCode2(self.addModal.form.govCode1);
    },
    "addModal.dropDownList.govCode2s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.addModal.form.govCode2 != "")
        this.modalGetSearchGovCode3(self.addModal.form.govCode2);
    },
    "addModal.dropDownList.govCode3s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.addModal.form.govCode3 != "")
        this.modalGetSearchGovCode4(self.addModal.form.govCode3);
    },
    "addModal.dropDownList.jobGovCode1s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.addModal.form.jobGovCode1 != "")
        this.modalGetSearchJobGovCode2(self.addModal.form.jobGovCode1);
    },
    "addModal.dropDownList.jobGovCode2s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.addModal.form.jobGovCode2 != "")
        this.modalGetSearchJobGovCode3(self.addModal.form.jobGovCode2);
    },
    "addModal.dropDownList.jobGovCode3s": function (newValue, oldValue) {
      const self = this;
      if (newValue != [] && self.addModal.form.jobGovCode3 != "")
        this.modalGetSearchJobGovCode4(self.addModal.form.jobGovCode3);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
